import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Drawer from '@mui/material/Drawer';
import { modalClasses } from './modal.classes';
import { useModalStyles } from './modal.styles';
export const ModalSmallViewport = ({ isOpen, className, styles, disableTransition = false, children, role, onClose, ...rest })=>{
    const css = useModalStyles();
    const backdropSlotProps = {
        classes: {
            root: modalClasses.backdrop
        },
        style: styles?.backdrop,
        sx: css.backdrop,
        ...disableTransition && {
            transitionDuration: {
                enter: 0,
                exit: 0
            }
        }
    };
    return /*#__PURE__*/ _jsx(Drawer, {
        ...rest,
        onClose: onClose,
        role: role ?? 'dialog',
        "aria-modal": "true",
        anchor: "bottom",
        open: isOpen,
        classes: {
            paperAnchorBottom: modalClasses.container
        },
        className: className,
        transitionDuration: disableTransition ? {
            enter: 0,
            exit: 0
        } : {
            enter: 200,
            exit: 100
        },
        slotProps: {
            backdrop: backdropSlotProps
        },
        PaperProps: {
            sx: {
                color: 'inherit'
            }
        },
        style: styles?.root,
        css: css.root,
        children: children
    });
};

//# sourceMappingURL=modalSmallViewport.js.map